
export default {
	productOptionTypeList: state => state.productOptionTypeIds.map(id => state.productOptionTypes[id]),
}